<template>
  <div class="tw-flex tw-gap-[30px] tw-items-center">
    <div
      class="tw-flex tw-items-center tw-gap-[5px] tw-text-[12px] tw-text-forText"
      v-if="showLimitInput"
    >
      <span class="">Выводить по</span>
      <div class="multiselect-type-2">
        <BaseSelect
          v-model="limitValue"
          style="width: 56px"
          placeholder=""
          selectLabel=""
          deselectLabel=""
          @input="setSelect"
          id="city"
          label="label"
          :options="[
            { label: 1, value: 1 },
            { label: 50, value: 50 },
            { label: 100, value: 100 },
            { label: 500, value: 500 },
            { label: 1000, value: 1000 },
          ]"
        >
        </BaseSelect>
      </div>
      записей
    </div>
    <div class="tw-text-[12px]">
      <span class="tw-text-forText">Показано</span>
      <span class="tw-text-forTitle">
        {{ paginationParams.count }} из {{ paginationParams.total }}
      </span>
    </div>

    <ul
      :class="containerClass"
      v-if="!noLiSurround"
      class="page-list tw-list-none tw-flex tw-gap-[5px] tw-p-0 tw-m-0"
    >
      <li v-if="firstLastButton && pagesLength > 1">
        <button
          @click="selectFirstPage()"
          @keyup.enter="selectFirstPage()"
          :class="[pageLinkClass, firstPageSelected() ? disabledClass : '']"
          tabindex="0"
          class="tw-app-btn-primary-outline !tw-p-[7px] tw-h-[26px] tw-w-[26px]"
        >
          <img
            :src="require(`@/assets/icons/pagination-1.svg`)"
            class="tw-rotate-180 tw-transform"
          />
        </button>
      </li>

      <li
        v-if="!(firstPageSelected() && hidePrevNext)"
        :class="[
          prevClass,
          firstPageSelected() ? disabledClass : '',
          pageClass,
        ]"
      >
        <button
          class="tw-app-btn-primary-outline !tw-p-[7px] tw-h-[26px] tw-w-[26px]"
          @click="prevPage()"
          @keyup.enter="prevPage()"
          :class="[prevLinkClass, pageLinkClass]"
          :tabindex="firstPageSelected() ? -1 : 0"
        >
          <img
            :src="require(`@/assets/icons/pagination-2.svg`)"
            class="tw-rotate-180 tw-transform"
          />
        </button>
      </li>

      <li
        v-for="page in pages"
        :class="[
          pageClass,
          page.selected ? activeClass : '',
          page.disabled ? disabledClass : '',
          page.breakView ? breakViewClass : '',
        ]"
      >
        <button
          class="tw-app-btn-primary-outline !tw-p-[7px] tw-h-[26px] tw-w-[26px]"
          v-if="page.breakView"
          :class="[pageLinkClass, breakViewLinkClass]"
          tabindex="0"
        >
          <slot name="breakViewContent">{{ breakViewText }}</slot>
        </button>
        <button v-else-if="page.disabled" :class="pageLinkClass" tabindex="0">
          {{ page.content }}
        </button>
        <button
          v-else
          class="tw-app-btn-primary-outline tw-h-[26px] !tw-px-[10px]"
          @click="handlePageSelected(page.index + 1)"
          @keyup.enter="handlePageSelected(page.index + 1)"
          :class="pageLinkClass"
          tabindex="0"
        >
          {{ page.content }}
        </button>
      </li>

      <li
        v-if="!(lastPageSelected() && hidePrevNext)"
        :class="[nextClass, lastPageSelected() ? disabledClass : '', pageClass]"
      >
        <button
          class="tw-app-btn-primary-outline !tw-p-[7px] tw-h-[26px] tw-w-[26px]"
          @click="nextPage()"
          @keyup.enter="nextPage()"
          :class="[prevLinkClass, pageLinkClass]"
          :tabindex="lastPageSelected() ? -1 : 0"
        >
          <img :src="require(`@/assets/icons/pagination-2.svg`)" />
        </button>
      </li>

      <li v-if="firstLastButton && pagesLength > 1">
        <button
          @click="selectLastPage()"
          @keyup.enter="selectLastPage()"
          :class="[pageLinkClass, lastPageSelected() ? disabledClass : '']"
          tabindex="0"
          class="tw-app-btn-primary-outline !tw-p-[7px] tw-h-[26px] tw-w-[26px]"
        >
          <img :src="require(`@/assets/icons/pagination-1.svg`)" />
        </button>
      </li>
    </ul>

    <!-- <div :class="containerClass">
      <a
        v-if="firstLastButton"
        @click="selectFirstPage()"
        @keyup.enter="selectFirstPage()"
        :class="[pageLinkClass, firstPageSelected() ? disabledClass : '']"
        tabindex="0"
        v-html="firstButtonText"
      ></a>
      <a
        v-if="!(firstPageSelected() && hidePrevNext)"
        @click="prevPage()"
        @keyup.enter="prevPage()"
        :class="[prevLinkClass, firstPageSelected() ? disabledClass : '']"
        tabindex="0"
        v-html="prevText"
      ></a>
      <template v-for="page in pages">
        <a
          v-if="page.breakView"
          :class="[
            pageLinkClass,
            breakViewLinkClass,
            page.disabled ? disabledClass : '',
          ]"
          tabindex="0"
          ><slot name="breakViewContent">{{ breakViewText }}</slot></a
        >
        <a
          v-else-if="page.disabled"
          :class="[
            pageLinkClass,
            page.selected ? activeClass : '',
            disabledClass,
          ]"
          tabindex="0"
          >{{ page.content }}</a
        >
        <a
          v-else
          @click="handlePageSelected(page.index + 1)"
          @keyup.enter="handlePageSelected(page.index + 1)"
          :class="[pageLinkClass, page.selected ? activeClass : '']"
          tabindex="0"
          >{{ page.content }}</a
        >
      </template>
      <a
        v-if="!(lastPageSelected() && hidePrevNext)"
        @click="nextPage()"
        @keyup.enter="nextPage()"
        :class="[nextLinkClass, lastPageSelected() ? disabledClass : '']"
        tabindex="0"
        v-html="nextText"
      ></a>
      <a
        v-if="firstLastButton"
        @click="selectLastPage()"
        @keyup.enter="selectLastPage()"
        :class="[pageLinkClass, lastPageSelected() ? disabledClass : '']"
        tabindex="0"
        v-html="lastButtonText"
      ></a>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    defaultValueLimit: {
      type: Number,
      default: 100,
    },
    paginationParams: {
      type: Object,
    },
    value: {
      type: Number,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    forcePage: {
      type: Number,
    },
    clickHandler: {
      type: Function,
      default: () => {},
    },
    pageRange: {
      type: Number,
      default: 3,
    },
    marginPages: {
      type: Number,
      default: 1,
    },
    prevText: {
      type: String,
      default: "Prev",
    },
    nextText: {
      type: String,
      default: "Next",
    },
    breakViewText: {
      type: String,
      default: "…",
    },
    containerClass: {
      type: String,
    },
    pageClass: {
      type: String,
    },
    pageLinkClass: {
      type: String,
    },
    prevClass: {
      type: String,
    },
    prevLinkClass: {
      type: String,
    },
    nextClass: {
      type: String,
    },
    nextLinkClass: {
      type: String,
    },
    breakViewClass: {
      type: String,
    },
    breakViewLinkClass: {
      type: String,
    },
    activeClass: {
      type: String,
      default: "active",
    },
    disabledClass: {
      type: String,
      default: "disabled",
    },
    noLiSurround: {
      type: Boolean,
      default: false,
    },
    firstLastButton: {
      type: Boolean,
      default: true,
    },
    firstButtonText: {
      type: String,
      default: "First",
    },
    lastButtonText: {
      type: String,
      default: "Last",
    },
    hidePrevNext: {
      type: Boolean,
      default: false,
    },
    showLimitInput: {
      type: Boolean,
      default: true,
    },
  },
  beforeUpdate() {
    if (this.forcePage === undefined) return;
    if (this.forcePage !== this.selected) {
      this.selected = this.forcePage;
    }
  },
  computed: {
    pagesLength() {
      return Object.keys(this.pages)?.length;
    },
    selected: {
      get: function () {
        return this.value || this.innerValue;
      },
      set: function (newValue) {
        this.innerValue = newValue;
      },
    },
    pages: function () {
      let items = {};
      if (this.pageCount <= this.pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1,
          };
          items[index] = page;
        }
      } else {
        const halfPageRange = Math.floor(this.pageRange / 2);
        console.log(
          halfPageRange,
          this.pageRange,
          "-------------const halfPageRange"
        );
        let setPageItem = (index) => {
          let page = {
            index: index,
            content: index + 1,
            selected: index === this.selected - 1,
          };

          items[index] = page;
        };

        let setBreakView = (index) => {
          let breakView = {
            disabled: true,
            breakView: true,
          };

          items[index] = breakView;
        };

        // 1st - loop thru low end of margin pages
        for (let i = 0; i < this.marginPages; i++) {
          setPageItem(i);
        }

        // 2nd - loop thru selected range
        let selectedRangeLow = 0;
        if (this.selected - halfPageRange > 0) {
          selectedRangeLow = this.selected - 1 - halfPageRange;
        }

        let selectedRangeHigh = selectedRangeLow + this.pageRange - 1;
        if (selectedRangeHigh >= this.pageCount) {
          selectedRangeHigh = this.pageCount - 1;
          selectedRangeLow = selectedRangeHigh - this.pageRange + 1;
        }

        for (
          let i = selectedRangeLow;
          i <= selectedRangeHigh && i <= this.pageCount - 1;
          i++
        ) {
          setPageItem(i);
        }

        // Check if there is breakView in the left of selected range
        if (selectedRangeLow > this.marginPages) {
          setBreakView(selectedRangeLow - 1);
        }

        // Check if there is breakView in the right of selected range
        if (selectedRangeHigh + 1 < this.pageCount - this.marginPages) {
          setBreakView(selectedRangeHigh + 1);
        }

        // 3rd - loop thru high end of margin pages
        for (
          let i = this.pageCount - 1;
          i >= this.pageCount - this.marginPages;
          i--
        ) {
          setPageItem(i);
        }
      }
      return items;
    },
  },
  data() {
    return {
      innerValue: 1,
      limitValue: 50,
    };
  },
  mounted() {
    if (this.paginationParams.limit) {
      this.limitValue = {
        label: this.paginationParams.limit,
        value: this.paginationParams.limit,
      };
    }
  },
  methods: {
    setSelect(data) {
      this.$emit("updateLimitValue", data.value);
    },
    handlePageSelected(selected) {
      if (this.selected === selected) return;

      this.innerValue = selected;
      this.$emit("input", selected);
      this.clickHandler(selected);
    },
    prevPage() {
      if (this.selected <= 1) return;

      this.handlePageSelected(this.selected - 1);
    },
    nextPage() {
      if (this.selected >= this.pageCount) return;

      this.handlePageSelected(this.selected + 1);
    },
    firstPageSelected() {
      return this.selected === 1;
    },
    lastPageSelected() {
      return this.selected === this.pageCount || this.pageCount === 0;
    },
    selectFirstPage() {
      if (this.selected <= 1) return;

      this.handlePageSelected(1);
    },
    selectLastPage() {
      if (this.selected >= this.pageCount) return;

      this.handlePageSelected(this.pageCount);
    },
  },
};
</script>

<style lang="scss">
.page-list .active button {
  background: #52648e2b !important;
}
</style>
